"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _reactTransitionGroup = require("react-transition-group");
var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));
var _Close = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/01-Interface-Essential/33-Form-Validation/Close"));
var _getDistanceScrolled = _interopRequireDefault(require("@berlitz/max-utils/lib/getDistanceScrolled"));
var _bodyScrollLock = require("@berlitz/max-utils/lib/bodyScrollLock");
var _Modal = require("./Modal.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);
  var _super = _createSuper(Modal);
  function Modal(props) {
    var _this;
    _classCallCheck(this, Modal);
    _this = _super.call(this, props);
    _this.innerModal = /*#__PURE__*/_react.default.createRef();
    _this.outerModal = /*#__PURE__*/_react.default.createRef();
    _this.state = {
      offset: 0
    };
    return _this;
  }
  _createClass(Modal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open) {
        this.handleModalOpenClose();
      }
    }
  }, {
    key: "handleModalOpenClose",
    value: function handleModalOpenClose() {
      var distanceScrolled = (0, _getDistanceScrolled.default)();
      this.setState({
        offset: distanceScrolled
      });
      if (this.props.open) {
        setTimeout(function () {
          (0, _bodyScrollLock.addBodyScrollLock)();
        }, this.animationDuration);
      } else {
        (0, _bodyScrollLock.removeBodyScrollLock)();
        document.querySelector('body').style.top = null;
        window.scrollTo(0, this.state.offset);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        onClose = _this$props.onClose,
        children = _this$props.children,
        open = _this$props.open,
        size = _this$props.size,
        theme = _this$props.theme;
      this.animationDuration = theme.animation.duration.medium;
      var handleKeyDown = function handleKeyDown(evt) {
        if (evt.which === 27) onClose();
      };
      var handleOutsideClick = function handleOutsideClick(evt) {
        if (_this2.outerModal.current && !_this2.innerModal.current.contains(evt.target)) {
          onClose();
        }
      };
      if (open) {
        // Set this.state.offset as a 'top' style on the body while the model is open.
        // This allows us to prevent scrolling of the background, while faking
        // the user's scroll position. When using addBodyScrollLock() alone, users are
        // scrolled to the top of the page and scroll position is lost.
        document.querySelector('body').style.top = "-".concat(this.state.offset, "px");
      }
      return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, {
        in: open,
        timeout: this.animationDuration,
        exit: true,
        mountOnEnter: true,
        unmountOnExit: true
      }, function (state) {
        return /*#__PURE__*/_react.default.createElement(_focusTrapReact.default, null, /*#__PURE__*/_react.default.createElement(_Modal.Wrapper, {
          onKeyDown: handleKeyDown,
          ref: _this2.outerModal,
          onClick: handleOutsideClick,
          "data-key": "max-modal",
          state: state
        }, /*#__PURE__*/_react.default.createElement(_Modal.Container, {
          size: size,
          role: "dialog",
          "aria-modal": "true",
          "aria-label": "modal window",
          ref: _this2.innerModal,
          "data-key": "max-modal__box",
          state: state
        }, /*#__PURE__*/_react.default.createElement(_Modal.ModalControl, null, /*#__PURE__*/_react.default.createElement(_Modal.ClearButton, {
          onClick: onClose,
          "aria-label": "Close Modal",
          "data-key": "max-modal__box__button--close"
        }, /*#__PURE__*/_react.default.createElement(_Close.default, {
          size: "xs"
        }))), /*#__PURE__*/_react.default.createElement(_Modal.ModalContent, {
          "data-key": "max-modal__box__content"
        }, children))));
      });
    }
  }]);
  return Modal;
}(_react.default.Component);
Modal.defaultProps = {
  open: false,
  size: 'sm'
};
var _default = (0, _styledComponents.withTheme)(Modal);
exports.default = _default;